export default class workshop {
    workshopId = '';
    workshopDate = '';
    workshopTime = '';
    personInGroup = 2;
    teamName = '';
    language = '';
}